import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row align-items-center py-4" }
const _hoisted_2 = { class: "col-lg-6 col-7" }
const _hoisted_3 = { class: "h2 text-white d-inline-block mb-0" }
const _hoisted_4 = {
  "aria-label": "breadcrumb",
  class: "d-none d-md-inline-block ml-md-4"
}
const _hoisted_5 = { class: "container-fluid mt--5" }
const _hoisted_6 = { class: "row px-xl-5 px-xxl-6" }
const _hoisted_7 = { class: "col-lg-12 p-0" }

import RouteBreadcrumb from "@/components/Breadcrumb/RouteBreadcrumb.vue";
import BaseHeader from "@/components/BaseHeader.vue";
import Table from "@/components/TablePaginated.vue";
import { onMounted, computed } from "vue";
import { HistoryModule } from "@/store/modules/History";
import { AuthModule } from "@/store/modules/Auth";
export interface IPagination {
	page: number;
	limit: number;
	filter: string;
	sendNumber?: boolean;
	agentCode?: string;
	today?: boolean;
	type?:string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const CallHistory = computed(() => {
	return HistoryModule.HistoryCall ? HistoryModule.HistoryCall : {};
});
const loading = computed(() => {
	return HistoryModule.callLoading;
});
const user = computed(() => AuthModule.user);
const itemValues = [{value:"my_history",label:"Mi historial"},{value:"global_search",label:"Buscador global"}];

onMounted(() => {
	setTimeout(() => {
		HistoryModule.updateCallHistory();
	}, 1000);
});
let timer: ReturnType<typeof setTimeout>;

function callback(pag: IPagination, select="") {
	console.log(select)
	pag != undefined
		? HistoryModule.updateCallHistory({...pag,type:select})
		: HistoryModule.updateCallHistory(undefined);
}
function callInputback(pag: IPagination, select="") {
	console.log(select)
	clearTimeout(timer); // Reiniciar el temporizador
	timer = setTimeout(function () {
		callback(pag,select);
	}, 500);
}


return (_ctx: any,_cache: any) => {
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BaseHeader, { class: "pb-6" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$route.name), 1),
            _createElementVNode("nav", _hoisted_4, [
              _createVNode(RouteBreadcrumb)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_card, { class: "no-border-card" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(Table, {
                onUpdateData: _cache[0] || (_cache[0] = 
								(payload) => {
									callback({ ...payload.pagination, sendNumber: false, agentCode: _unref(user)?.code?? '', today: true} as any,payload.typeSelect);
								}
							),
                onUpdateInputData: _cache[1] || (_cache[1] = 
								(payload) => {

									callInputback({ ...payload.pagination, sendNumber: false, agentCode: _unref(user)?.code?? '', today: true},payload.typeSelect);
								}
							),
                tableData: _unref(CallHistory),
                load: _unref(loading),
                tittle: "Historial de llamadas",
                tittlebtn: "Actualizar",
                disabled: false,
                btn: false,
                filter: true,
                cardClass: "m-1",
                tableLayout: "fixed",
                select: true,
                selectArray: itemValues,
                defaultSelect: itemValues[0].value
              }, null, 8, ["tableData", "load", "defaultSelect"])
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})